<template>
  <div>
    <div class="mypersonHot" v-if="homeranklist && homeranklist.length > 0">
      <div class="playersmall">
        <div class="videoInfo" v-if="fristLive.item">
          <!-- <ali-player v-if="source" ref="players" @play="play($event)" @pause="pause($event)"
            @liveStreamStop="liveStreamStop($event)" :autoplay="true"  :rePlay="false"
            showBuffer="true" showBarTime="5000" format="flv" :source="source">
          </ali-player> -->

          <el-image fit="contain"  :src="fristLive.item.cover  + '?x-oss-process=image/resize,m_fill,w_1168,h_846/quality,q_100&timestamp=' + imageTime">
            <div slot="error" class="image-slot">
               <img src="@/assets/img/defaultLogo.png" alt="" />
            </div>
          </el-image>

          <div class="hotValueImg"  v-if="fristLive.item.fixHeatFlag == 1">
            <img src="@/assets/img/hotlabels.png" alt="" srcset="">
          </div>
          <div ref="PushLiveStreaming"
            @click="Jinruzhibojian(fristLive.live.id, fristLive.live.stream.flv,fristLive.item.virtualId)"
            class="videoMovieinto">
            <span>进入直播间</span>
          </div>
        </div>
        <div
          style="width:584px;display: flex;background: #FFFFFF;justify-content: center;height: 73px; flex-direction: column;border-radius:0  0 6px 6px ;    box-sizing: border-box;box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.1);">
          <div class="home-right-div" v-if="fristLive.item">
            <div style="display: flex;justify-content:space-between ">
              <div class="home-right-div-title myfont"> {{ fristLive.item.title }}</div>
              <div v-if="isCare(fristLive.user.uid)" @click.stop="guanzhu(fristLive.user, false)" class="careOk">
                已关注
              </div>
              <div v-else @click.stop="guanzhu(fristLive.user, true)" class="attention">
                关注
              </div>
            </div>
            <div class="hotValue">
              <div class="video_list_img">
                <img :src="fristLive.user.avatar" alt="" />
              </div>
              <div class="home-right-div-title2">
                <div class="name2">
                  {{ fristLive.user.nickname | nameFilters }}
                </div>
                <div class="hotName">
                  <img src="https://oss.ansongqiubo.com/assets/home/icon_huo@2x.png" alt="" />
                  <div>{{ fristLive.item.heatValue }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="home-right-bottom">
        <div class="home-right-bottomItem" v-for="(item, index) in homeranklist" v-if="item && index < 5 && index > 0"
          :key="index">
          <liveItem @login='login' :liveDetailitems='item'></liveItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import aliplayer from "../../components/aaaaaa.vue";
  import liveItem from "@/components/lz_liveItem.vue";
  import axios from "axios";
  import qs from "qs";
  import {
    homerank,
    roomInfo
  } from '../../api/lz.js';
  import mixin from './mixins/mixinCare'
  export default {
    components: {
      'ali-player': aliplayer,
      liveItem
    },
    mixins: [mixin],
    data() {
      return {
        careList: [],
        fristLive: {},
        key: 'value',
        homeranklist: [],
        first_soft: 0,
        imageTime: '',
        isLive: true,
        source: '',
      }
    },
    methods: {
      login() {
        this.$emit("emitLongin");
      },
      isCare(uid) {
        // console.log("object 1:>> ", uid);
        let arr = this.careList.filter((item) => item.uid == uid);
        if (arr && arr.length > 0) {
          return true;
        } else {
          return false;
        }
      },
      // 关注主播
      guanzhu(val, state) {
        this.token = localStorage.getItem("token");
        if (!this.token) {
          this.$emit("emitLongin");
          return
        }
        if (state) {
          axios({
            headers: {
              device: "iOS",
              packageId: "1",
              version: "1.0.0",
              "authToken": this.token,
              "Content-Type": "application/x-www-form-urlencoded",
            },
            transformRequest: [
              function(data) {
                //在请求之前对data传参进行格式转换
                data = qs.stringify(data);
                return data;
              },
            ],
            url: this.api + "/v1/relation/follow",
            method: "post",
            data: {
              actionUid: val.uid,
            },
          }).then((res) => {
            this.$message({
              message: "关注成功",
              type: "success",
            });
            this.getcareListData(2);
            console.log("关注主播", res);
          });
        } else {
          this.$confirm("取关该主播将无法及时收到消息, 是否取关?", "温馨提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              axios({
                headers: {
                  device: "iOS",
                  packageId: "1",
                  version: "1.0.0",
                  "authToken": this.token,
                  "Content-Type": "application/x-www-form-urlencoded",
                },
                transformRequest: [
                  function(data) {
                    //在请求之前对data传参进行格式转换
                    data = qs.stringify(data);
                    return data;
                  },
                ],
                url: this.api + "/v1/relation/unfollow",
                method: "post",
                data: {
                  actionUid: val.uid,
                },
              }).then((res) => {
                console.log(res);
                this.$message({
                  message: "取关成功",
                  type: "success",
                });
                // 判断是分类列表还是 关注列表
                if (this.first_soft == 99) {
                  this.getcare();
                } else {
                  this.getcareListData(2);
                }
              });
            })
            .catch(() => {});
        }
      },
      // 获取关注列表
      async getcareListData(type = 1) {
        this.token = localStorage.getItem("token");
        if (this.token) {
          let list = await this.$store.dispatch('getUserFollowData', type);
          console.log('我的关注列表-组件·', list);
          this.careList = list;
        }
      },
      getcare() {
        this.first_soft = 99;
        this.shouyeData = [];
        this.$axios
          .get(this.api + "/v1/relation/lives", {
            params: {
              // pcatId: 0,
              pageIndex: 0,
            },
            headers: {
              device: "web",
              packageId: "1",
              channel: "web",
              version: "1.0.0",
              "authToken": this.token,
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
          .then((res) => {
            console.log("关注列表", res);
            // this.$router.push({
            //   query: merge({ rid: 3, infoId: this.first_soft, valId: "" }),
            // });
            this.shouyeData = res.data.data;
          });
      },
      // 获取关注列表
      Jinruzhibojian(id, flv, virtualId) {
        const neww = this.$router.resolve({
          path: "/roominfo",
          query: {
            roomId: id,
            virtualId
          },
        })
        window.open(neww.href, '_self');
      },
      play(e) {

      },
      pause(e) {

      },
      liveStreamStop(e) {

      }
    },
    filters: {
      ellipsis(value) {
        if (!value) return "";
        if (value.length > 10) {
          return value.slice(0, 10) + "...";
        }
        return value;
      },
      nameFilters(value) {
        if (!value) return "";
        if (value.length > 10) {
          return value.slice(0, 10) + "...";
        }
        return value;
      },
    },

    created() {

      this.imageTime = Date.parse(new Date()) / 1000;
      // 人气榜
      homerank({
        rankType: 'popular',
        dataLength: 5
      }).then(res => {
        if (res.data.code == 200 && res.data.data.list) {
          this.homeranklist = []
          let arrlist = res.data.data.list;
          if (arrlist.length > 0 && arrlist[0]) {
            let roomid = arrlist[0].live.id;
            this.fristLive = arrlist.splice(0, 1)[0];
          }
          this.homeranklist = arrlist;
          console.log('热门直播。。。。。。。', arrlist);
          this.homeranklist.push(arrlist[0])
        }
      })
    },

  }
</script>

<style lang="scss" scoped>
  @import "../../assets/style/index.scss"; //引入全局scss

  .mypersonHot {
    display: flex;
    max-width: 1200px;
    width: 100%;
    justify-content: space-between;

    .attention {
      cursor: pointer;
      display: block;
      padding: 6px 18px;
      border-radius: 18px;
      background: linear-gradient(270deg, #F75325 0%, #ED1010 100%);
      color: #fff;
      font-size: 14px;
      text-align: center;
    }

    .careOk {
      cursor: pointer;
      display: block;
      padding: 6px 18px;
      border-radius: 18px;
      background: rgb(231, 231, 231);
      color: #fff;
      font-size: 14px;
      text-align: center;
    }
    .hotValueImg{
      width: 62px;
      height: 62px;
      position:absolute;
      left: 0;
      top: 0;
      img{
        width: 62px;
        height: 62px;
      }
    }
    .playersmall {
      display: flex;
      flex-direction: column;
      width: 584px;
      display: flex;
      border-radius: 6px;
      cursor: pointer;

      .videoInfo:hover .videoMovieinto {
        display: block !important;

      }

      .videoInfo {
        width: 584px;
        height: 423px;
        background: #FFFFFF;
        border-radius: 6px 6px 0 0;
        overflow: hidden;
        object-fit: cover !important;
        position: relative;
        .el-image{
            width: 584px;
            height: 423px;
          img{
            width: 584px;
            height: 423px;
          }
        }
        /deep/ video {
          object-fit: cover !important;
        }

        .videoMovieinto {
          display: none;
          color: #1076e9;
          text-align: center;
          background: rgba(51, 51, 51, 0.5);
          position: absolute;
          width: 200px;
          height: 56px;
          line-height: 56px;
          // background-color: #111;
          opacity: 0.7;
          border: 1px solid #1076e9;
          border-radius: 30px;
          left: calc(50% - 100px);
          top: calc(50% - 47px);
          font-size: 20px;
          font-weight: 700;
          cursor: pointer;
        }

        img {
          object-fit: cover;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: 50%;
          position: absolute;
          width: 100%;
          height: 100%;
        }
      }

      .prism-player video {
        position: static !important;
        width: auto !important;
        z-index: 20 !important;
        width: 594px !important;
        height: 398px !important;
        height: auto;
        left: 50%;
        top: 50%;

        transform: none !important;
        -ms-transform-origin: center;
        -moz-transform-origin: center;
        -webkit-transform-origin: center;
        -o-transform-origin: center;
      }
    }

    .home-right-div {
      /* height: 30%; */
      display: flex;
      height: 80px;
      flex-flow: column wrap;
      box-sizing: border-box;
      padding: 8px;

      .hotValue {
        display: flex;
        margin-top: 8px;
      }

      .video_list_img {
        width: 22px;
        height: 22px;
        margin-right: 4px;
        border-radius: 50%;
        overflow: hidden;

        img {
          width: 22px;
          height: 22px;
        }
      }
    }

    .home-right-div-title2 {
      display: flex;
      justify-content: space-between;
      flex: 2;
      align-items: center;

      .hotName {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        display: flex;
        align-items: center;

        img {
          margin-right: 2px;
          width: 11px;
          height: 11px;
        }
      }

      .name2 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }

    .home-right-bottom {
      margin-left: 12px;
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start !important;

      /deep/ .home-right-li {
        width: 294px;
        height: 238px;
        background: #ffffff;
        border-radius: 6px;
        box-sizing: border-box;
        list-style-type: none;
        background-color: $bgNav;
        overflow: hidden;
        transition: all 0.3s;

        .image-slot {
          width: 294px;
          height: 168px;

          img {
            width: 294px;
            height: 168px;
          }
        }

        .home-right-info {
          width: 294px;
          height: 165px;
          img{
            width: 294px;
            height: 165px;
          }
        }

        .home-right-div-title {
          font-size: 14px;
          width: 265px;

          .attention {
            cursor: pointer;
            display: block;
            padding: 6px 18px;
            border-radius: 18px;
            background: linear-gradient(270deg, #F75325 0%, #ED1010 100%);
            color: #fff;
            font-size: 14px;
            text-align: center;
          }

          .careOk {
            cursor: pointer;
            display: block;
            padding: 6px 18px;
            border-radius: 18px;
            background: rgb(231, 231, 231);
            color: #fff;
            font-size: 14px;
            text-align: center;
          }
        }
      }

      .home-right-bottomItem:nth-child(2n) {
        /deep/ .home-right-li {
          margin-right: 0 !important;
        }
      }

      .attention,
      .careOk {
        display: none;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/template/template_hotlist.vue